@if (isVisible()) {
  <div
    class="option-wrapper w-100 py-2 px-3"
    [ngClass]="{
      'option-selected': selected(),
      'text-gray': disabled(),
    }"
    (click)="onClick()"
  >
    <span class="fw-normal"
      >{{ label() }} {{ disabled() ? '(disabled)' : '' }}</span
    >
  </div>
}
